/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".editingInput_f8579c9e{border:0;outline:0}.editingInput_f8579c9e::-ms-clear{display:none}.editingContainer_f8579c9e{margin:4px}"}]);
export const editingInput = "editingInput_f8579c9e";
export const editingContainer = "editingContainer_f8579c9e";